// The route line again, this time carrying progress: the rail fills to where the
// order has got to, and a marker sits at that point. On an order that is
// actually moving the marker pulses; on one that is waiting or done it does not,
// because a pulse that never means anything stops meaning anything.
const FILL = { pending: 4, accepted: 34, picked_up: 68, delivered: 100, cancelled: 0 }

const MOVING = ['accepted', 'picked_up']

const End = ({ label, place, pin }) => (
  <div>
    <p className="text-label font-semibold uppercase text-ink-3">{label}</p>
    <p className="mt-0.5 text-body text-ink">{place}</p>
    <p className="mt-0.5 text-body-s text-ink-3 tabular-nums">{pin}</p>
  </div>
)

export default function JourneyRail({ status, pickup, pickupPin, dropoff, dropoffPin }) {
  const cancelled = status === 'cancelled'
  const fill = FILL[status] ?? 0

  return (
    <div className="grid grid-cols-[16px_1fr] gap-x-3.5 items-stretch">
      <div aria-hidden="true" className="relative flex flex-col items-center py-1.5">
        <span className="flex-none w-[11px] h-[11px] rounded-full bg-brand" />

        <span className="relative flex-1 w-0.5 min-h-[96px] rounded-[1px] bg-hairline">
          <span
            className="absolute left-0 top-0 w-0.5 rounded-[1px] bg-brand transition-[height] duration-settle ease-out"
            style={{ height: `${fill}%` }}
          />
          <span
            className={`absolute left-1/2 w-[9px] h-[9px] -ml-[4.5px] -mt-[4.5px] rounded-full
                        shadow-[0_0_0_4px_var(--blush)] transition-[top] duration-settle ease-out
                        ${cancelled ? 'bg-alert' : 'bg-brand'}
                        ${MOVING.includes(status) ? 'animate-pulse-ring' : ''}`}
            style={{ top: `${fill}%` }}
          />
        </span>

        <span className="flex-none w-[11px] h-[11px] rounded-full border-2 border-brand" />
      </div>

      <div className="flex flex-col justify-between gap-4 min-w-0">
        <End label="Collect from" place={pickup} pin={pickupPin} />
        <End label="Deliver to" place={dropoff} pin={dropoffPin} />
      </div>
    </div>
  )
}
